import type {SupportedLocales} from '@/lib/locale/locale'
import type {Reward} from '@/models/rewardModel'
import {createQueryConfig} from '@/utils/query/query'

export default createQueryConfig({
  rewards: (locale: SupportedLocales) => ({
    key: ['rewards', locale],
    data: [] as Reward[],
  }),
  referrer: () => ({
    key: ['referrer'],
    data: false,
  }),
})
